@if (hasData) {

  @if (searchQuery) {
    <sd-title [titleLevel]="1" class="is-text-center"
      [customClass]="isMobile$ ? 'is-body-l' : 'is-body-xl'"
      [titleThemesConfig]="themesEnum.dark"
    >
      {{ 'searchResultPage.title' | translate: {total: getTotals(), query: '"' + searchQuery + '"'} }}
    </sd-title>
  }

  <sd-tab-group (selectedTabIndexChange)="changeTab($event)"
    [(selectedTabIndex)]="selectedTabIndex"
    [layout]="tabGroupLayoutEnum.buttons"
  >
    <sd-tab>
      <ng-container sd-tab-title>
        <span>{{ 'searchResultPage.sectionTitles.products' | translate: { total: totals.products } }}</span>
      </ng-container>
      <div sd-tab-pane>
        @if (currentTab === 'product' && totals.products > 0) {
          <wc-product-card-grid
            class="is-embedded"
            [isGlobal]="true"
            [disableProductComparator]="true"
            [context]="context"
            [isLoading]="useLazyLoad && !gridLoaded"
            (hasLoaded)="onGridLoaded()"
          />
        }
      </div>
    </sd-tab>

    <sd-tab>
      <ng-container sd-tab-title>
        <span>{{ 'searchResultPage.sectionTitles.accessories' | translate: { total: totals.accessories } }}</span>
      </ng-container>
      <div sd-tab-pane>
        @if (currentTab === 'accessoryProduct' && totals.accessories > 0) {
          <wc-product-card-grid
            class="is-embedded"
            [isAccessories]="true"
            [isGlobal]="true"
            [disableProductComparator]="true"
            [context]="context"
            [isLoading]="useLazyLoad && !gridLoaded"
            (hasLoaded)="onGridLoaded()"
          />
        }
      </div>
    </sd-tab>

    @if (isRecipesEnabled) {
      <sd-tab>
        <ng-container sd-tab-title>
          <span>{{ 'searchResultPage.sectionTitles.recipes' | translate: { total: totals.recipes } }}</span>
        </ng-container>
        <div sd-tab-pane>
          @if (currentTab === 'recipes' && totals.recipes > 0) {
            <wc-recipe-search [(alreadySearchedRecipe)]="savedRecipeSearchWithParams" />
          }
        </div>
      </sd-tab>
    }

    <sd-tab>
      <ng-container sd-tab-title>
        <span>{{ 'searchResultPage.sectionTitles.faq' | translate: { total: totals.faq } }}</span>
      </ng-container>
      <div sd-tab-pane>
        @if (currentTab === 'faq' && totals.faq > 0) {
          <wc-faq-search-list [totalFaqs]="totals.faq" />
        }
      </div>
    </sd-tab>

    <sd-tab>
      <ng-container sd-tab-title>
        <span>{{ 'searchResultPage.sectionTitles.ifu' | translate: { total: totals.ifu } }}</span>
      </ng-container>
      <div sd-tab-pane>
        @if (currentTab === 'ifu' && totals.ifu > 0) {
          <wc-product-card-grid
            class="is-embedded"
            [isGlobal]="true"
            [isLoading]="useLazyLoad && !gridLoaded"
            (hasLoaded)="onGridLoaded()"
          />
        }
      </div>
    </sd-tab>
  </sd-tab-group>

} @else {

  <div class="container">
    <div class="row justify-content-center">
      <div class="col-24 col-m-20">
        <div class="empty-search-result-page-template">
          <sd-wysiwyg
            [title]="title"
            [titleLevel]="1"
            [textConfig]="textConfig"
            [mediaConfig]="mediaConfig"
            [mediaTop]="image"
          >
            @if (!!searchQuery) {
              <p class="is-body-l">&laquo; {{ searchQuery }} &raquo;</p>
            }
            <sd-wysiwyg-paragraph [title]="subtitle" [content]="content" />
          </sd-wysiwyg>
        </div>
      </div>
    </div>
  </div>
}
